import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=bb4eb158&lang=scss&scoped=true"

import exportComponent from "D:\\Git\\monetwareProjects\\kunqu-opera-test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb4eb158"]])

export default __exports__